import { render, staticRenderFns } from "./editAttnGroup.vue?vue&type=template&id=0dcb5699&"
import script from "./editAttnGroup.vue?vue&type=script&lang=js&"
export * from "./editAttnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports